/** If some preference is not defined, then it’s set to fallback */
export const companyPreferencesFallback: CompanyPreferences = {
  createProjects: 'admins',
  editPosition: 'self',
  seeEmails: 'admins',
  editOwnEmail: 'all',
  seeLicensePage: 'all',
  seeStatsPage: 'managers',
  createGroupChat: 'all',
  setAutoTaskCoverForNewBoards: false,
  useOldId: false,
  useNewGantt: true
}

/** New companies have this default */
export const companyPreferencesDefault: CompanyPreferences = {
  createProjects: 'all',
  editPosition: 'self',
  seeEmails: 'all',
  editOwnEmail: 'all',
  seeLicensePage: 'all',
  seeStatsPage: 'managers',
  createGroupChat: 'all',
  setAutoTaskCoverForNewBoards: false,
  useOldId: false,
  useNewGantt: true
}

/** company-wide settings stored in company hub */
export type CompanyPreferencesUserKind = 'all' | 'managers' | 'admins'

export interface CompanyPreferences {
  createProjects: CompanyPreferencesUserKind
  editPosition: 'self' | 'managers' | 'admins'
  seeEmails: CompanyPreferencesUserKind
  editOwnEmail: CompanyPreferencesUserKind
  seeLicensePage: CompanyPreferencesUserKind
  seeStatsPage: CompanyPreferencesUserKind
  createGroupChat: CompanyPreferencesUserKind
  setAutoTaskCoverForNewBoards: boolean
  useOldId: boolean
  useNewGantt: boolean
}
